import { render, staticRenderFns } from "./PointProgramsList.vue?vue&type=template&id=ad0f9522&scoped=true&"
import script from "./PointProgramsList.vue?vue&type=script&lang=js&"
export * from "./PointProgramsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0f9522",
  null
  
)

export default component.exports